export default {
  data() {
    return {
      width: 375,
      height: 210,
      contentHeight: 300
    };
  },
  mounted() {
    // console.log('window.devicePixelRatio = ', window.devicePixelRatio);
    this.width = document.documentElement.clientWidth;
    this.height = (document.documentElement.clientWidth * 9) / 16;
    this.contentHeight = document.documentElement.clientHeight - this.height - 48;
  }
};
